// extracted by mini-css-extract-plugin
module.exports = {"layer":"ChipMorphLayer_layer__2Hhz3","box":"ChipMorphLayer_box__UN4YC","face":"ChipMorphLayer_face__CIfIh"};